'use client'

import { Fragment } from 'react'

import { ArticlesLatestItemType } from '@/lib/models/components/articlesLatest.types'
import { CardArticle } from '@/lib/ui-kit/components/CardArticle.component'
import { ButtonLinkInternal } from '@/lib/ui-kit/components/ui/ButtonLinkInternal.component'

export const ListArticlesLatest = ({
  articlesLatest,
  children,
}: {
  articlesLatest: ArticlesLatestItemType[]
  children: React.ReactNode
}) => {
  return (
    <>
      {/* INFO: temporarily section above is used as section header */}
      {/* <div className="caption pb-4 pl-10">Latest stories</div> */}
      {articlesLatest &&
        articlesLatest.map((article, index) => {
          if (index === articlesLatest.length - 2)
            return (
              <Fragment key={index}>
                <CardArticle
                  key={article.title}
                  category={article.category}
                  title={article.title}
                  description={article.description}
                  authorName={article.authorName}
                  datePublication={article.datePublication}
                  linkArticle={article.linkArticle}
                  image={article.imageCard}
                />
                <div className="xl:hidden">{children}</div>
              </Fragment>
            )

          return (
            <CardArticle
              key={article.id}
              category={article.category}
              title={article.title}
              description={article.description}
              authorName={article.authorName}
              datePublication={article.datePublication}
              linkArticle={article.linkArticle}
              image={article.imageCard}
            />
          )
        })}
      <ButtonLinkInternal
        linkUrl="/blog/all-stories"
        className="ml-10 mt-10 xl:mt-12"
      >
        All stories
      </ButtonLinkInternal>
    </>
  )
}
